import { render, staticRenderFns } from "./user_mgr.vue?vue&type=template&id=53740439&"
import script from "./user_mgr.vue?vue&type=script&lang=js&"
export * from "./user_mgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports